import { QueryStringFilter } from '../../../models/query-string.model'
import { Page } from '../../../models/util.model'
import { BrandPageData } from '../models/brand-listing.model'
import {
  BrandSearchField,
  BrandSearchParams,
} from '../models/brand-search.model'
import { Brand, BrandProductsCount } from '../models/brand.entity'

/**
 * Parse filter params
 * @param params - the search params
 * @param filter - the filter to parse
 * @returns the brand search params updated
 */
export function brandFilterParams(
  params: BrandSearchParams,
  filter: QueryStringFilter<BrandSearchField>,
): BrandSearchParams {
  const searchParams: BrandSearchParams = {}

  switch (filter.field) {
    case '_id':
      if (filter.operator === '=') {
        searchParams._id = filter.value
      }
      break
    case 'name':
      if (filter.operator === '=') {
        searchParams.name = filter.value
      } else if (filter.operator === 'contains') {
        searchParams['name:ct'] = filter.value
      }
      break
    case 'externalId':
      if (filter.operator === '=') {
        searchParams.externalId = filter.value
      } else if (filter.operator === 'contains') {
        searchParams['externalId:ct'] = filter.value
      }
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}

/**
 * Parse a brand page and product counts to a single page data
 * @param brandPage - the brand page
 * @param productsCounts - the product counts
 * @returns the brands page data
 */
export function parseBrandsPage(
  brandPage: Page<Brand>,
  productsCounts?: BrandProductsCount[],
): Page<BrandPageData> {
  const data = brandPage.data.map((b) => ({
    ...b,
    productsCount: productsCounts?.find((c) => c._id === b._id)?.count,
  }))
  return {
    totalCount: brandPage.totalCount,
    data,
  }
}
